import firebase, { errorsCollection } from "../firebase";
import { v4 as uuidv4 } from "uuid";
import { getCurrentUserId, getBoardIdFromURL } from "./../util/common";

class ErrorService {
  constructor() {}

  async createErrorObject(err) {
    const errorPayoload = {
      boardId: getBoardIdFromURL(),
      id: uuidv4(),
      datatime: firebase.firestore.FieldValue.serverTimestamp(),
      current_user_id: getCurrentUserId(),
      error: {
        message: err?.message ?? "",
        name: err?.name ?? "",
        stack: err?.stack ?? "",
      },
    };
    try {
      return errorsCollection.add(errorPayoload);
    } catch (ex) {
      console.error("failed to log error", ex);
    }
  }
}

export default new ErrorService();
